import React, { type FC } from "react";
import TwemojiWrapper from "../../components/TwemojiWrapper/TwemojiWrapper";

interface Props {
  emoji: string;
}

const KC_PrizeIcon: FC<Props> = ({ emoji }) => {
  if (!emoji) {
    return null;
  }
  return <TwemojiWrapper isBigText={true}>{emoji}</TwemojiWrapper>;
};

export default KC_PrizeIcon;
